<template>
   <div>
      <!--FORM View-->
      <transition name="fade">
         <component :api="api" :data="editData" :dataKey="dataKey"
                    :updateAllData="updateAllData" :alwaysUpdate="alwaysUpdate"
                    :is="formComponent" :key="formRender" :newTitle="newTitle" :obj="objRoot"
                    @onCommand="formCommand" style="animation-duration: 0.3s;" v-if="formState"/>
      </transition>

      <!--GRID View-->
      <transition name="fade">

         <crud-grid :api="api" :columns="gridColumns" :dataKeyName="dataKeyName"
                    :filterBy="pageFilters || filterBy" :key="gridRender"
                    :obj="obj"
                    :options="gridOptions"
                    :settings="gridSettings"
                    @onDataLoaded="onDataLoaded"
                    @onNewClick="onNewClick"
                    @onRefreshClick="onRefreshClick"
                    @onRowClick="onRowClick"
                    @onSelectionChange="onSelectionChange"
                    ref="crudGrid"
                    style="animation-duration: 0.4s;"
                    v-show="gridState">

            <template slot="gridHeader">
               <slot name="gridHeader"></slot>
            </template>
            <template slot="gridFooter">
               <slot name="gridFooter"></slot>
            </template>

         </crud-grid>

      </transition>

   </div>

</template>

<script>
   import CrudGrid from './crudGrid';

   export default {
      name: 'crud',
      components: { CrudGrid },

      props: {
         formComponent: {
            type: Function,
            required: false
         },
         formRoute: {
            type: String,
            required: false
         },
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         filterBy: {
            type: Object,
            required: false
         },
         pageFilters: {
            type: Object,
            required: false
         },
         filterRowOptions: {
            type: Object,
            required: false,
            default: () => {
               return {
                  noFilterText: null,
                  autoHide: true
               };
            }
         },
         dataKeyName: {
            type: String,
            required: false,
            default: 'id'
         },
         gridSettings: {
            type: Object,
            required: false
         },
         gridOptions: {
            type: Object,
            required: false
         },
         gridColumns: {
            type: Array,
            required: false
         },
         updateAllData: {
            type: Boolean,
            default: false
         },
         alwaysUpdate: {
            type: String,
            default: ''
         }
      },

      data: () => ({
         formRender: 0,
         dataKey: undefined,
         crudState: 'grid',
         gridRender: 0,
         editData: null
      }),

      watch: {
         crudState () {
            this.formRender = +new Date(); //force form component to be completely rendered again
            this.$emit('onCrudStateChange', this.crudState);
            /*if (this.crudState === 'grid') {
               this.$appState.viewTitle = (this.$route.meta) ? this.$route.meta.title : this.$route.name;
            }*/
         },
         filterBy () {
            if (this.formState) {
               this.formCommand('back');
            }
         }
      },

      computed: {
         gridState () {
            return (this.crudState === 'grid');
         },
         formState () {
            return (this.crudState === 'form');
         },
         newTitle () {
            return (this.gridOptions && this.gridOptions.newLabel) ? this.gridOptions.newLabel : null;
         },
         objRoot () {
            return this.obj.split('/')[0];
         }
      },

      methods: {
         formCommand (command) {
            console.log(command);
            switch (command) {
               case 'reload':
                  this.backAndReload();
                  break;
               case 'back':
                  this.crudState = 'grid';
                  break;
               case 'next':
                  this.nextRecord();
                  break;
               case 'previous':
                  this.previousRecord();
                  break;
            }
         },

         onDataLoaded (data) {
            this.$emit('onDataLoaded', data);
         },

         onSelectionChange (selectedRows) {
            this.$emit('onGridSelection', selectedRows);
         },

         onRefreshClick () {
            this.$emit('onRefreshClick');
         },

         onNewClick () {
            this.$emit('onNewClick');
            this.newRecord();
         },

         onRowClick (data) {
            this.$emit('onRowClick', data);
            this.editRecord(data.id);
         },

         backAndReload () {
            this.gridRender = +new Date();
            this.crudState = 'grid';
         },

         nextRecord () {


         },

         previousRecord () {

         },

         newRecord () {
            if (this.formComponent) {
               this.editData = null;
               this.dataKey = undefined;
               this.crudState = 'form';
            } else if (this.formRoute) {
               this.$router.push({ path: this.formRoute + '/new' });
            }
         },

         async editRecord (key) {
            console.log(this.objRoot, ' - EditRecord: ', key);
            if (this.formComponent) {
               let aRecord = await this.$api[this.api].getById(this.objRoot, key);
               this.editData = this.$util.objectCopy(aRecord);
               this.dataKey = key;
               this.crudState = 'form';
            } else if (this.formRoute) {
               this.$router.push({ path: this.formRoute + '/' + key });
            }

         },

         refreshGrid () {
            this.$refs.crudGrid.refresh();
         },

         gridDeleteRow (key) {
            return this.$refs.crudGrid.deleteRow(key);
         },

         gridUpdateRow (key, values) {
            return this.$refs.crudGrid.updateRow(key, values);
         }

      }

   };

</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/crudPage/crud.vue